export default __webpack_public_path__ + "static/media/cage.bfbf268b.jpg";